import {createToggleStore} from './createToggleStore'

export default createToggleStore('recording')
